import type { ProviderInfo } from './types';

/**
 * Fetch the platform's enabled OAuth providers. The list is sorted by
 * `priority` ascending; the consumer (sign-in page) picks the first as
 * "recommended" by default, or hand-picks Discord if present (it's the
 * primary identity for the FFXIV community).
 */
export async function fetchProviders(): Promise<ProviderInfo[]> {
    const res = await fetch('/.well-known/auth/providers', { credentials: 'include' });
    if (!res.ok) throw new Error(`Providers HTTP ${res.status}`);
    const all = (await res.json()) as ProviderInfo[];
    return all
        .filter((p) => p.enabled)
        .sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));
}
